import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { TrackPersonalization } from '@app/+catalog/store';

/**
 * When the user open personalization modal
 */
const events = getEvents(({ payload }: TrackPersonalization) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      eventCategory: 'my preferences',
      ...payload
    }
  }
]);

export default events;
